import React, { Component } from 'react'
import { TYPES_MAP as MEDIA_TYPES } from "./media"
import { TYPES_MAP as RICH_TEXT_TYPES } from "./rich_text"
import { List } from './list'
import Editable from "../editable/index";

const TYPES_MAP = Object.assign(
  MEDIA_TYPES,
  RICH_TEXT_TYPES,
  {
    'list/links': List,
    'list/items': List
  }
)

const Content = (props) => {
  const Component = TYPES_MAP[props.editable.type.toString()]
  const state = Object.assign({}, props, {editable: null})
  return (
    <Editable {...props}>
      <Component { ...props } />
    </Editable>
  )
}

export default Content


// WEBPACK FOOTER //
// ./app/javascript/app/site/components/content/index.js